<h1 mat-dialog-title>
  {{(data.isNewUser ? 'administration.users.add' : 'administration.users.edit') | translate}}
  <div style="float: right">
    <fa-icon [icon]="data.isNewUser ? faUserAdd : faUserEdit"></fa-icon>
  </div>
</h1>
<mat-divider></mat-divider>
<form name="userForm" [formGroup]="userFormGroup">
  <div mat-dialog-content>
    <mat-form-field appearance="outline" color="primary">
      <mat-label>{{'administration.users.user-name' | translate}}</mat-label>
      <input matInput name="userName" [formControl]="userNameFormControl" autocomplete="off" required>
      <mat-error *ngIf="userNameFormControl.hasError('required')">
        {{'common.field-required' | translate}}
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" color="primary">
      <mat-label>{{'administration.users.first-name' | translate}}</mat-label>
      <input matInput name="firstName" [formControl]="firstNameFormControl" autocomplete="off" required>
      <mat-error *ngIf="userNameFormControl.hasError('required')">
        {{'common.field-required' | translate}}
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" color="primary">
      <mat-label>{{'administration.users.last-name' | translate}}</mat-label>
      <input matInput name="lastName" [formControl]="lastNameFormControl" autocomplete="off" required>
      <mat-error *ngIf="userNameFormControl.hasError('required')">
        {{'common.field-required' | translate}}
      </mat-error>
    </mat-form-field>
    <div class="outline-group" *ngIf="isUserAdmin()">
      <label>{{'administration.users.role' | translate}} *</label>
      <div formArrayName="roles">
        <div *ngFor="let role of roles.controls; let i = index">
          <mat-checkbox [formControlName]="i">
            {{'administration.users.roles.' + roleEnum[i+1] | lowercase | translate}}
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="is-active">
      <mat-slide-toggle formControlName="isActive">{{'common.active' | translate}}
      </mat-slide-toggle>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()" type="button" color="warn">{{'common.cancel' | translate}}</button>
    <button mat-button (click)="onOkClick()" type="submit" [mat-dialog-close]="data" [disabled]="!userFormGroup.valid"
      color="accent">{{'common.save' | translate}}</button>
  </div>
</form>